export default {
  translation: {
    common: {
      emailOrUsername: '이메일 혹은 사용자 이름',
      invalidEmailOrUsername: '이메일 혹은 사용자 이름이 유효하지 않습니다',
      invalidPassword: '유효하지 않은 비밀번호',
      logInToPlanka: 'Planka에 로그인',
      noInternetConnection: '인터넷 연결이 없음',
      pageNotFound_title: '페이지를 찾을 수 없습니다',
      password: '비밀번호',
      projectManagement: '프로젝트 관리',
      serverConnectionFailed: '서버 연결에 실패함',
      unknownError: '알 수 없는 오류, 나중에 다시 시도하십시오',
      useSingleSignOn: 'single sign-on(SSO) 사용',
    },

    action: {
      logIn: '로그인',
      logInWithSSO: 'single sign-on(SSO)으로 로그인',
    },
  },
};
